module.exports = __webpack_public_path__ + "static/media/portfolio-masonry-4.30d436bc.jpg";